import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

const InstallAppPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosPrompt, setShowIosPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed || isStandalone()) return;

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    if (isIos()) {
      setShowIosPrompt(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, [dismissed]);

  const installApp = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setDismissed(true);
  };

  if (dismissed || isStandalone()) return null;
  if (!deferredPrompt && !showIosPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[70] lg:left-auto lg:right-6 lg:w-[420px]">
      <Card className="border-primary/30 shadow-2xl bg-card/95 backdrop-blur">
        <CardContent className="p-4 space-y-3">
          <p className="font-semibold">Install The Eagle App</p>
          {deferredPrompt ? (
            <p className="text-sm text-muted-foreground">
              Install this app for a full-screen experience and faster launch from your home screen.
            </p>
          ) : (
            <p className="text-sm text-muted-foreground">
              On iPhone/iPad: tap Share, then choose "Add to Home Screen" to install this web app.
            </p>
          )}
          <div className="flex gap-2 justify-end">
            <Button variant="ghost" onClick={() => setDismissed(true)}>
              Not now
            </Button>
            {deferredPrompt && (
              <Button onClick={installApp}>
                Install App
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default InstallAppPrompt;
